import { useMemo } from 'react';
import type { UseResourceCustomContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/types.tsx';
import { useProjectSidebarNavigation } from '../../common/project-sidebar-navigation-resource/index.tsx';
import { getCanEditShortcuts } from './utils/index.tsx';

export const useCanEditShortcuts = (customContext?: UseResourceCustomContext): boolean => {
	const { data } = useProjectSidebarNavigation(customContext);

	return useMemo(() => data && getCanEditShortcuts(data), [data]) || false;
};
